module.exports = __webpack_public_path__ + "static/media/salmon.43861041.png";